import { render, staticRenderFns } from "./product-content.vue?vue&type=template&id=dc634b10"
import script from "./product-content.vue?vue&type=script&lang=ts"
export * from "./product-content.vue?vue&type=script&lang=ts"
import style0 from "./product-content.vue?vue&type=style&index=0&id=dc634b10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports